module.exports = __webpack_public_path__ + "assets/d446d80d191a72fcdb949bc684874d93.mp4";